import { useEffect, useState } from 'react';
import { IEnderecoCleanDTO, IEnderecoDTO, IFornecedorDTO, IPaisCleanDTO } from '../../../../models/happy-code-api.model';
import { usePaisService } from '../../../../services/pais.service';
import { useGlobalContext } from '../../../../context/GlobalContext';
import { useLogradouroService } from '../../../../services/logradouro.service';
import { Predicate } from '../../../../models/predicate.model';
import { useNotificationService } from '../../../../services/notification.service';

export default function useEnderecoHook(fornecedor: IFornecedorDTO, setFornecedor: React.Dispatch<React.SetStateAction<IFornecedorDTO>>) {
	const [pais, setPais] = useState<IPaisCleanDTO[]>();
	const paisService = usePaisService();
	const logradouroService = useLogradouroService();
	const notification = useNotificationService();
	const { setIsGlobalLoading } = useGlobalContext();

	const findPais = async () => {
		const response = await paisService.findCleanList();
		setPais(response.data);
	};

	useEffect(() => {
		setIsGlobalLoading(true);
		findPais().finally(() => setIsGlobalLoading(false));
	}, []);

	const onCepChange = (cep: string) => {
		setFornecedor({ ...fornecedor, endereco: { ...fornecedor.endereco, cep: cep } });
		const endereco = { ...fornecedor.endereco } as IEnderecoDTO;

		if (cep.length !== 8) {
			return;
		}

		setIsGlobalLoading(true);

		const predicateLogradouro = new Predicate(10);
		predicateLogradouro.addOption('cep', cep);

		logradouroService
			.findCustom(predicateLogradouro)
			.then(({ data }) => {
				if (data && data.length > 0) {
					const logradouro = data[0];

					endereco.cep = logradouro.cep;
					endereco.bairro = logradouro.bairroNome;
					endereco.cidade = logradouro.cidadeNome;
					endereco.logradouro = logradouro.nomeCompleto;
					endereco.nomeUF = logradouro.cidadeEstadoNome;
					endereco.uf = logradouro.cidadeEstadoCodigo;
					endereco.paisId = logradouro.cidadeEstadoPaisId;

					setFornecedor({
						...fornecedor,
						endereco,
					});
				} else {
					notification({
						description: 'CEP não encontrado',
						type: 'warning',
						message: 'Aviso',
					});
					setFornecedor({
						...fornecedor,
						endereco: {
							cep: cep,
							bairro: '',
							cidade: '',
							logradouro: '',
							nomeUF: '',
							uf: '',
							paisId: null,
							numero: '',
							complemento: '',
						} as IEnderecoCleanDTO,
					});
				}
			})
			.finally(() => setIsGlobalLoading(false));
	};

	return {
		pais,
		setPais,
		onCepChange,
	};
}
